import React from "react";
import {default as MuiMenuItem} from "@mui/material/MenuItem";

const MenuItem = props => {
    const {children, ...other} = props;
    return (
        <MuiMenuItem
            classes={{
                root: "ch-menuItem",
            }}
            {...other}
        >
            {children}
        </MuiMenuItem>
    )
}

export default MenuItem;